import { useNavigate } from "react-router-dom";
import { Eye, Loader2 } from "lucide-react";

import "./OrderTable.css";

function OrderTable({
    orders,
    loading,
}) {

    const navigate = useNavigate();

    if (loading) {
        return (
            <div className="loading-state">
                <Loader2
                    size={42}
                    className="spin"
                />
                <p>Loading Orders...</p>
            </div>
        );
    }

    if (orders.length === 0) {
        return (
            <div className="empty-state">
                <h3>No Orders Found</h3>
                <p>No customer orders available.</p>
            </div>
        );
    }

    return (
        <div className="order-table-wrapper">

            <table className="order-table">

                <thead>

                    <tr>

                        <th>Order No</th>

                        <th>Customer</th>

                        <th>Provider</th>

                        <th>Items</th>

                        <th>Total</th>

                        <th>Payment</th>

                        <th>Status</th>

                        <th>Date</th>

                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {orders.map((order) => (

                        <tr key={order._id}>

                            <td>

                                <strong>
                                    {order.orderNumber}
                                </strong>

                            </td>

                            <td>

                                <div className="customer-info">

                                    <strong>
                                        {order.customerSnapshot?.name}
                                    </strong>

                                    <small>
                                        {order.customerSnapshot?.phone}
                                    </small>

                                </div>

                            </td>

                            <td>

                                <div className="provider-info">

                                    <strong>
                                        {order.providerSnapshot?.businessName}
                                    </strong>

                                    <small>
                                        {order.providerSnapshot?.phone}
                                    </small>

                                </div>

                            </td>

                            <td>

                                {order.items?.length || 0} Items

                            </td>

                            <td>

                                ₹{order.grandTotal}

                            </td>

                            <td>

                                <span
                                    className={
                                        order.payment?.status === "Paid"
                                            ? "payment-paid"
                                            : "payment-pending"
                                    }
                                >
                                    {order.payment?.status}
                                </span>

                            </td>

                            <td>

                                <span
                                    className={`status-badge status-${order.status?.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    {order.status}
                                </span>

                            </td>

                            <td>

                                {new Date(order.createdAt)
                                    .toLocaleDateString()}

                            </td>

                            <td>

                                <button
                                    className="details-btn"
                                    onClick={() =>
                                        navigate(`/admin/orders/${order._id}`)
                                    }
                                >

                                    <Eye size={18} />

                                    <span>
                                        View Details
                                    </span>

                                </button>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
}

export default OrderTable;